/**
 * This directive is only used on the video playlists/favorites page. It adds buttons to remove videos from the current playlist.
 */
const ngVideoRemove = ['$http', $http => ({
    /**
     * @param $scope
     * @param $element
     * @param $params {{ ngVideoRemove, listId, message, csrfName, csrfValue }}
     */
    link($scope, $element, $params) {
        const clickEvent = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';

        $element[0].querySelectorAll('.video-item').forEach(video => {
            const thumb = video.querySelector('.video-item-thumb');
            if (!thumb) {
                return;
            }

            const videoLink = video.querySelector('.video-item-link');
            if (!videoLink) {
                return;
            }

            const found = videoLink.getAttribute('href').match(/^\/?video\/([0-9]+)\/?/i);
            const videoId = +found[1];

            const button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.setAttribute('class', 'button-playlist-remove');
            button.innerHTML = '&times;';
            thumb.appendChild(button);

            button.addEventListener(clickEvent, async () => {
                if (!window.confirm($params.message)) {
                    return;
                }

                const data = {
                    [$params.csrfName]: $params.csrfValue,
                    movie_id: videoId,
                    playlist_id: +$params.listId,
                };

                const response = await $http.post($params.ngVideoRemove, data);
                if (response.data.success) {
                    video.remove();
                }
            });
        });
    }
})];

export default ngVideoRemove;

